module.exports = __webpack_public_path__ + "img/step00_green.ca438247.png";